<template>
  <div class="positions">
    <ul class="position-list">
      <li
        class="position-item"
        v-for="{ label, img, imgSrc } of positionList"
        :key="img"
      >
        <img
          class="position-img"
          :style="[img == '1.png' ? compCssStyles : {}]"
          :src="imgSrc"
          alt="#"
        />

        <p class="position-lable text-md">{{ label | trim | toUpper }}</p>
      </li>
    </ul>

    <v-annotation>
      {{ dic.sectionPositions.msg1 }}
    </v-annotation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VAnnotation from '@/components/ui/VAnnotation'
export default {
  name: 'ThePositions',
  components: {
    VAnnotation,
  },
  computed: {
    ...mapGetters('positions', {
      positionList: 'getPositionList',
    }),
   currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },

    compCssStyles: function() {
      const defStyles = {
        height: '97px',
        width: '94px',
      }

      if (this.$mq.resize && this.$mq.below(414)) {
        defStyles.height = '90px'
        defStyles.width = '87px'
      }

      return defStyles
    },
  },
}
</script>

<style lang="scss" scoped>
.positions {
  background-image: url('../../assets/img/backgrounds/artboard2.webp'),
    url('../../assets/img/backgrounds/artboard2.jpg');
  background-position: center;
  background-size: cover;

  text-align: center;

  width: 100%;
  background-color: #facb0a;

  padding: 0;
  margin: 0;
}

.position-list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  padding: 100px 25px;

  margin: 0 auto;
  max-width: 990px;
}

.position-item {
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.position-img {
  width: 90px;
  align-self: flex-start;
  margin: 0 auto;
}

.position-lable {
  margin-top: 25px;
  text-align: center;
  font-weight: 500;
}
</style>

<style lang="scss" scoped>
@media (max-width: 375px), (max-width: 414px) {
  .position-list {
    padding: 50px 10px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: baseline;
  }

  .position-item {
    height: 100px;
    // background-color: red;
    margin: 30px;
  }
}
</style>
